import { render, staticRenderFns } from "./PageTitle.vue?vue&type=template&id=61fbdbe6&scoped=true&"
var script = {}
import style0 from "./PageTitle.vue?vue&type=style&index=0&id=61fbdbe6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fbdbe6",
  null
  
)

export default component.exports